<div #toastOutlet></div>

<app-modal
  #deleteModal
  label="Delete User"
  description="Are you sure you want to delete this user? This action cannot be undone."
  (confirmed)="confirmDelete()" />

<div class="flex">
  <div class="flex min-h-0 flex-col w-full p-11 card">
    <div class="flex md:justify-between justify-center md:flex-row flex-col gap-4 mb-4">
      <p class="lg:text-4xl text-2xl font-bold" data-testid="users-page-header">
        Users
      </p>
      <app-button
        data-testid="create-user-button"
        color="primary"
        label="+ Create"
        (clicked)="openCreateModal()" />
    </div>
    <div class="flex items-center mb-4">
      <div class="relative md:w-72 w-full">
        <input
          data-testid="search-users-input"
          id="search-users-input"
          type="text"
          name="search"
          placeholder="mail@myorder.ai"
          class="input input-bordered w-full rounded-lg placeholder-gray-300"
          (input)="searchQuery.set($any($event.target).value)" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 absolute right-3 top-1/2 -translate-y-1/2 text-gray-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </div>
    <div
      class="overflow-x-auto rounded-box border border-base-content/5 bg-base-100">
      <table class="table">
        <thead>
          <tr class="bg-gray-100 text-gray-800">
            <th role="columnheader" name="Email">Email</th>
            <th role="columnheader" name="First-name">First-name</th>
            <th role="columnheader" name="Last-name">Last-name</th>
            <th role="columnheader" name="Username">Username</th>
            <th role="columnheader" name="Role">Role</th>
            <th class="text-center" role="columnheader" name="Tools">Tools</th>
          </tr>
        </thead>
        <tbody>
          @if (isUsersLoading()) {
          <tr data-testid="loading-state">
            <td colspan="6" class="text-center">
              <span class="loading loading-dots loading-lg"></span>
            </td>
          </tr>
          } @else if (!usersList() || filteredUsers().length === 0) {
          <tr>
            <td
              colspan="6"
              class="text-center text-gray-400"
              data-testid="users-empty">
              No users found.
            </td>
          </tr>
          } @else { @for (user of filteredUsers(); track user.userId) {
          <tr data-testid="user-row">
            <td data-testid="user-email">{{ user.email }}</td>
            <td data-testid="user-first-name">{{ user.firstName }}</td>
            <td data-testid="user-last-name">{{ user.lastName }}</td>
            <td data-testid="user-username">{{ user.username }}</td>
            <td data-testid="user-role">
              {{ user.roles.toLocaleUpperCase() }}
            </td>
            <td class="justify-center flex gap-2">
              <!-- Edit button -->
              <button
                id="edit-user-button"
                class="hover:cursor-pointer"
                (click)="openEditModal(user.userId)"
                data-testid="edit-user-button">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.56123 17.3251L19.3137 6.57255C20.0495 5.88699 20.3523 4.85451 20.1035 3.88016C19.8546 2.9058 19.0938 2.14497 18.1195 1.89614C17.1451 1.6473 16.1126 1.95016 15.4271 2.68588L4.64706 13.4659C4.57811 13.5368 4.51948 13.617 4.47289 13.7042L1.92456 18.8467C1.78521 19.1311 1.80253 19.4673 1.97039 19.7359C2.13825 20.0045 2.43285 20.1674 2.74956 20.1667C2.9008 20.1632 3.04882 20.1222 3.18039 20.0476L8.32289 17.4992C8.41011 17.4526 8.49034 17.394 8.56123 17.3251ZM19.2496 20.1667C19.7558 20.1667 20.1662 19.7563 20.1662 19.2501C20.1662 18.7438 19.7558 18.3334 19.2496 18.3334H10.9996C10.4933 18.3334 10.0829 18.7438 10.0829 19.2501C10.0829 19.7563 10.4933 20.1667 10.9996 20.1667H19.2496ZM14.9596 8.33255L13.6671 7.04005L6.07706 14.6667L4.80289 17.2334L7.33289 15.9226L14.9596 8.33255ZM17.3841 3.66557C17.6354 3.66557 17.8757 3.76871 18.0487 3.95088C18.2274 4.12769 18.3256 4.37009 18.3204 4.62137C18.3152 4.87266 18.207 5.11079 18.0212 5.28005L16.2521 7.04005L14.9596 5.74755L16.7196 3.95088C16.8926 3.76871 17.1329 3.66557 17.3841 3.66557Z"
                    fill="#3F3F46" />
                </svg>
              </button>

              <!-- Delete button -->
              <button
                id="delete-user-button"
                class="hover:cursor-pointer"
                (click)="onDeleteUser(user.userId)"
                data-testid="delete-user-button">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.4163 1.83301H4.58301C3.06422 1.83301 1.83301 3.06422 1.83301 4.58301V6.41634C1.83301 6.9226 2.24341 7.33301 2.74967 7.33301H3.66634V17.4163C3.66634 18.9351 4.89756 20.1663 6.41634 20.1663H15.583C17.1018 20.1663 18.333 18.9351 18.333 17.4163V7.33301H19.2497C19.7559 7.33301 20.1663 6.9226 20.1663 6.41634V4.58301C20.1663 3.06422 18.9351 1.83301 17.4163 1.83301ZM16.4997 17.4163C16.4997 17.9226 16.0893 18.333 15.583 18.333H6.41634C5.91008 18.333 5.49967 17.9226 5.49967 17.4163V7.33301H16.4997V17.4163ZM3.66634 5.49967H18.333V4.58301C18.333 4.07675 17.9226 3.66634 17.4163 3.66634H4.58301C4.07675 3.66634 3.66634 4.07675 3.66634 4.58301V5.49967ZM7.33301 15.583V10.083C7.33301 9.57675 7.74341 9.16634 8.24967 9.16634C8.75594 9.16634 9.16634 9.57675 9.16634 10.083V15.583C9.16634 16.0893 8.75594 16.4997 8.24967 16.4997C7.74341 16.4997 7.33301 16.0893 7.33301 15.583ZM12.833 10.083V15.583C12.833 16.0893 13.2434 16.4997 13.7497 16.4997C14.2559 16.4997 14.6663 16.0893 14.6663 15.583V10.083C14.6663 9.57675 14.2559 9.16634 13.7497 9.16634C13.2434 9.16634 12.833 9.57675 12.833 10.083Z"
                    fill="#3F3F46" />
                </svg>
              </button>
            </td>
          </tr>
          } }
        </tbody>
      </table>
    </div>
  </div>

  <!-- User Modal -->
  <app-user-modal
    [showUserModal]="showUserModal()"
    [mode]="modalMode()"
    [userData]="userDataForEdit()"
    (closed)="onModalClosed()"
    (userSaved)="onUserSaved()" />
</div>
